import Logo from 'components/Logo';
import MobileDrawerMenuButton from 'components/MobileDrawerMenuButton';
import OrganizationDropDown from 'components/OrganizationDropdown';
import TopBar from 'components/TopBar';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const HomePageTopBar: FunctionComponent<Props> = ({
    className = '',
    isOpen,
    onClick,
    testId = TEST_ID
}) => (
    <TopBar className={`${className} ${styles.homePageTopBar}`} testId={testId}>
        <Logo className={styles.logo} />

        <OrganizationDropDown />

        <MobileDrawerMenuButton
            className={styles.mobileDrawerMenuButton}
            isOpen={isOpen}
            onClick={onClick}
        />
    </TopBar>
);

export default HomePageTopBar;
